import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, Route, ActivatedRoute } from "@angular/router";
import { Base64Pipe } from '../../../services/pipes/base64/base64.pipe';
import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-manage-profile',
  templateUrl: './manage-profile.component.html',
  styleUrls: ['./manage-profile.component.css']
})
export class ManageProfileComponent implements OnInit {
  @ViewChild('Pond_Img') Pond_Img: any

  public DOC_URL            : any = AppSettings.DOC_URL;
  public profile_image_path : any = AppSettings.profile_image_path;
  public shifts             : any = AppSettings.agentShifts;
  public activeUser         : any;
  public agentId            : any;
  public agentDetails       : any = [];
  public agentDetails_Copy  : any = [];
  public agentForm          : FormGroup;
  public genders            : any = [
                                      { name: 'Male',   value: 1 },
                                      { name: 'Female', value: 2 }
                                    ];

  public passwordChange     : any = { oldPass: '', newPass: '', verifyPass: '' };
  public passForm           : FormGroup;
  public passSubmitted      : any = false;

  // Common Vars
  public browserSub         : any;
  public agentsSub          : any;
  public routerSubscription : any;
  public departments        : any;
  public regions            : any;
  public designations       : any;
  public teams              : any;
  public agents             : any;
  public qa                 : any;
  public loader             : any = false;
  public submitted          : any = false;
  public profileImage       : any = null;
  public FileLoader         : any = false;
  public hideFilePond       : any = true;
  public base64Pipe         : any = new Base64Pipe;
  public pondFiles          : any = [];


  public pondOptions = {
      acceptedFileTypes: 'image/jpeg, image/png',
      allowMultiple: false,
      labelIdle: `<svg width="80" height="68" viewBox="0 0 80 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M59.2363 66.9094C58.3274 66.5419 57.4766 66.0643 56.6269 65.5889C43.2899 65.5889 29.9533 65.594 16.6171 65.6043C16.1202 65.6043 16.0476 65.426 16.0498 64.999C16.0655 61.6634 16.0599 58.3268 16.0565 54.9846C16.0565 54.1428 15.6099 53.6157 14.8942 53.587C14.1428 53.5573 13.6102 54.0701 13.6079 54.8559C13.6012 57.0568 13.6079 59.2578 13.6079 61.4588C13.6079 62.6693 13.5968 63.8798 13.6146 65.0903C13.6146 65.4546 13.5365 65.6043 13.1245 65.6021C9.73904 65.5867 6.35213 65.5867 2.96373 65.6021C2.53274 65.6021 2.4356 65.4634 2.44006 65.065C2.45905 63.3428 2.40657 61.6183 2.46128 59.8928C2.50929 58.3774 2.97267 56.9369 3.57784 55.5547C5.05729 52.1608 7.47911 49.5923 10.8355 47.9614C13.5309 46.6408 16.3067 45.482 19.0367 44.2429C21.3323 43.2029 23.6324 42.1718 25.9113 41.0944C26.8716 40.6399 27.3316 39.7133 27.7257 38.8065C27.9491 38.3025 28.0953 38.2849 28.5408 38.5545C30.774 39.9059 33.1924 40.6333 35.8443 40.52C38.1701 40.4198 40.277 39.6693 42.2388 38.4852C42.6006 38.2651 42.71 38.3278 42.8719 38.691C43.4302 39.9367 44.1872 40.9392 45.574 41.5038C47.9579 42.4766 50.2636 43.6244 52.6083 44.6952L54.2653 42.7583C51.7497 41.6171 49.2542 40.4341 46.7129 39.3534C45.6376 38.8979 45.2066 38.0813 44.9096 37.0909C44.8587 36.9539 44.8529 36.8045 44.893 36.6641C44.9331 36.5236 45.0171 36.3992 45.133 36.3084C47.643 33.9864 49.5635 31.2462 51.0507 28.1968C52.538 25.1474 53.5552 21.9307 53.7562 18.528C53.9192 15.7526 53.3162 13.1015 52.0679 10.6045C49.9621 6.39852 46.7241 3.35936 42.3538 1.48708C39.4028 0.220428 36.3032 -0.291295 33.1076 0.163203C27.8341 0.912629 23.5866 3.45363 20.3788 7.63325C17.9659 10.785 16.7488 14.366 16.8605 18.3365C16.9308 20.6365 17.4467 22.8694 18.2283 25.0329C19.7792 29.3248 22.0983 33.1368 25.4692 36.2919C25.5886 36.402 25.7505 36.4966 25.7561 36.6815C25.7773 37.3528 25.1353 38.834 24.4163 39.1444C22.6298 39.9147 20.8667 40.7379 19.0936 41.5401C16.9665 42.5019 14.8283 43.4406 12.7147 44.4322C11.2241 45.1321 9.67316 45.7131 8.26629 46.5847C5.64343 48.1831 3.49653 50.4373 2.04368 53.1182C0.769687 55.47 -0.0197233 57.968 0.000374865 60.673C0.0137736 62.5614 0.000374865 64.4488 0.000374865 66.3372C0.000374865 67.6082 0.402337 68 1.70202 68H62.4721C62.8617 68 63.2537 67.978 63.64 67.967C62.1293 67.7898 60.6498 67.4784 59.2363 66.9094ZM21.4216 26.2754C20.5815 24.4794 19.967 22.5891 19.5916 20.6464C18.7486 16.2038 19.8149 12.2178 22.6208 8.69081C24.8383 5.9055 27.6878 3.98737 31.1625 3.02445C34.5703 2.08024 37.9334 2.27172 41.1904 3.6132C45.4891 5.38277 48.5709 8.40249 50.3294 12.6668C51.5521 15.6304 51.6057 18.6755 50.7939 21.7601C49.4976 26.6924 47.1193 31.0173 43.3565 34.5422C41.4092 36.3667 39.1526 37.6708 36.4338 38.0472C36.0497 38.1 35.6522 38.0912 35.2826 38.1099C32.7436 38.0736 30.564 37.1195 28.6056 35.6393C25.3463 33.1732 23.1132 29.9223 21.4216 26.2754Z" fill="#1C212D"/>
        <path d="M76.5486 43.9775C72.7701 39.3345 67.7043 37.653 61.7631 38.7579C58.86 39.2993 56.3879 40.7388 54.2665 42.7581L52.605 44.6873C51.4885 46.3919 50.5762 48.189 50.2178 50.2095C49.1146 56.4118 51.1468 61.4101 56.1925 65.242C56.3388 65.3521 56.4817 65.4621 56.6269 65.581C57.4766 66.0608 58.3274 66.5384 59.2363 66.9015C60.6499 67.4738 62.1293 67.7819 63.64 67.9624C64.0866 67.9712 64.5333 68.002 64.9799 67.9855C71.0685 67.7599 75.6766 65.0472 78.3373 59.6582C81.0506 54.1635 80.4353 48.7513 76.5486 43.9775ZM64.8425 65.5821C57.9444 65.5722 52.337 60.0114 52.337 53.1962C52.3424 49.9122 53.6705 46.7646 56.0295 44.4454C58.3885 42.1261 61.5854 40.825 64.9174 40.8279C71.8613 40.84 77.4709 46.4183 77.4564 53.2996C77.4418 60.0654 71.7675 65.5887 64.8425 65.5821Z" fill="#F07527"/>
        <path d="M70.4041 50.4915C69.8883 51.012 69.1435 50.9713 68.5361 50.3671C67.7545 49.5968 66.9919 48.8067 66.2204 48.0253L66.0987 48.1034V48.5767C66.0987 52.7739 66.0987 56.9715 66.0987 61.1694C66.0987 62.0366 65.6118 62.5461 64.8425 62.5153C64.5508 62.5126 64.2709 62.4016 64.0587 62.2043C63.8465 62.007 63.7177 61.738 63.6981 61.4512C63.6813 61.2685 63.6902 61.0847 63.6902 60.9009V47.9879C63.3285 48.3356 63.0717 48.5778 62.8193 48.8254C62.28 49.3569 61.7508 49.8972 61.2025 50.42C60.632 50.9647 59.9107 50.9955 59.416 50.5168C58.8957 50.0172 58.9147 49.2898 59.4953 48.7131C60.9736 47.2414 62.4594 45.777 63.9526 44.32C64.5779 43.7114 65.2333 43.7202 65.8653 44.3365C67.3459 45.7803 68.8197 47.2304 70.2869 48.6867C70.8753 49.2777 70.9133 49.9765 70.4041 50.4915Z" fill="#F07527"/>
      </svg>`,
      allowImagePreview: true,
      maxFileSize: '5MB',
      imagePreviewMaxFileSize: '5MB',
      // imagePreviewHeight: 170,

      // imageCropAspectRatio: '1:1',

      // imageResizeTargetWidth: 100,
      // imageResizeTargetHeight: 100,
      // stylePanelLayout: 'compact circle',

      // styleLoadIndicatorPosition: 'center bottom',
      // styleButtonRemoveItemPosition: 'center bottom',
      //
      // styleProgressIndicatorPosition: 'center bottom',
      // styleButtonProcessItemPosition: 'center bottom',

      server: {
          url: AppSettings.API_ENDPOINT,
          timeout: 200000,
          process: {
              url: './admin/upload-temp-files',
              method: 'POST',
              withCredentials: false,
              timeout: 30000,
              onload: (response) => {
                // Hide File Upload Loader
                this.FileLoader = false;

                let parsedData = JSON.parse(response);
                let decrptedImg = this.helperService.decrypted(parsedData.data);
                let image = JSON.parse(decrptedImg);

                // Add image to pro image array
                this.profileImage = image.id;

                return image.id;
              },
              onerror: (response) => {
                  // Hide File Upload Loader
                  this.FileLoader = false;

                  return response.key;
              },
              ondata: (formData) => {
                  // Show File Upload Loader
                  this.FileLoader = true;

                  return formData;
              }
          },
          revert: (uniqueFileId, load, error) => {
              // Rmeove from array
              this.profileImage = null;

              // Clear Image
              load();
          },
          restore : null,
          load    : null,
          fetch   : null
      }
  };

  constructor(
    private authenticationService : AuthenticationService,
    private helperService         : HelperService,
    private agentsService         : Agents,
    private activatedRoute        : ActivatedRoute,
    private router                : Router,
    private formBuilder           : FormBuilder,
  ) {
      this.browserSub = this.authenticationService.isBrowser.subscribe(isBrowser => {
        if (isBrowser) {
          // Get Agents
          this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
            if (agents) {
              this.departments    = agents.departments;
              this.regions        = agents.regions;
              this.designations   = agents.designations;
              this.teams          = agents.teams;
              this.agents         = agents.agents;
              this.qa             = agents.qa;
            }
          });

          this.activeUser = this.authenticationService.get_currentUserValue();
          this.agentId    = this.activeUser.user.id;
          this.getAgentDetails();
        }
      });
  }

  ngOnInit(): void {
    // Set FormGroup
    this.agentForm = this.formBuilder.group({
                      name              : [null, Validators.required],
                      email             : [null, Validators.required],
                      gender            : [null, Validators.required],
                      address           : [null],
                      intro             : [null],
                      cnic              : [null, Validators.required],
                      paypal            : [null],
                      // phone             : [null, Validators.required],
                      bank_detail       : [null],
                      bank_name         : [null],
                      bank_branchCode   : [null],
                      bank_acc_num      : [null],
                      bank_IBAN_num     : [null],
                    });

    // Set Pass FormGroup
    this.passForm = this.formBuilder.group({
                      oldPass       : [null, Validators.required],
                      newPass       : [null, Validators.required],
                      verifyPass    : [null, Validators.required],
                    });
  }

  getAgentDetails() {
    // Show Loader
    this.loader = true;

    let url = AppSettings.API_ENDPOINT + "admin/get-agent-details";
    let data = { id : this.agentId };

    this.helperService.httpPostRequestsDecryp(url, data).then(resp => {
      if(typeof resp != "undefined") {
        this.agentDetails      = JSON.parse(resp);

        // Set Image
        if(!this.agentDetails.image)
          this.hideFilePond = false;

        // Set Bank Details
        if(this.agentDetails.bank_detail) {
            let bank_details = this.agentDetails.bank_detail.trim().split('\r\n');
            this.agentDetails.bank_name       = bank_details[0] ? bank_details[0].split(':')[1].trim() : '';
            this.agentDetails.bank_branchCode = bank_details[1] ? bank_details[1].split(':')[1].trim() : '';
            this.agentDetails.bank_acc_num    = bank_details[2] ? bank_details[2].split(':')[1].trim() : '';
            this.agentDetails.bank_IBAN_num   = bank_details[3] ? bank_details[3].split(':')[1].trim() : '';
        } else {
            this.agentDetails.bank_name       = '';
            this.agentDetails.bank_branchCode = '';
            this.agentDetails.bank_acc_num    = '';
            this.agentDetails.bank_IBAN_num   = '';
        }

        if(this.agentDetails.gender == 0)
          this.agentDetails.gender = null;

        this.agentDetails_Copy = $.extend(true, {},  this.agentDetails);
      }

      // Hide Loader
      this.loader = false;
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.agentForm.controls; }

  updateAgent() {
    // Set Submission True
    this.submitted        = true;

    // Stop here if form is invalid
    if (this.agentForm.invalid) {
     return;
    }

    // Show Loader
    this.loader = true;

    // Set Bank Details Combined and profile Image
    this.agentDetails.bank_detail  = "Bank Name: " + this.agentDetails.bank_name + " \r\n Branch Code: " + this.agentDetails.bank_branchCode + " \r\n Account No.: " + this.agentDetails.bank_acc_num + " \r\n 24 Digit IBAN No.: " + this.agentDetails.bank_IBAN_num;

    if(this.profileImage)
      this.agentDetails.profileImage = this.profileImage;

    let url = AppSettings.API_ENDPOINT + "shared/update-agent-profile";

    this.helperService.httpPostRequests(url, this.agentDetails).then(resp => {
        if(typeof resp != "undefined") {
          if(typeof resp != "undefined") {
            if(resp && resp.status == 'OK') {
              Swal.fire('', resp.message, 'success');

              // Update Image
              if(this.profileImage) {
                this.agentDetails.image = resp.user[0].image;
                this.hideFilePond       = true;
              }

              // Update Copy
              this.agentDetails_Copy = $.extend(true, {},  this.agentDetails);
            }
            else
              Swal.fire('', JSON.stringify(resp.message), 'error');
          }
        }

        // Hide Loader
        this.loader = false;
    }).catch(err => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');


        // Hide Loader
        this.loader = false;
    });
  }

  openPassModal() {
    // Reset Feilds
    this.passwordChange = { oldPass: '', newPass: '', verifyPass: '' };
    this.passSubmitted  = false;

    // Open Modal
    ($('#resetPassword') as any).modal('show');
  }

  // convenience getter for easy access to form fields
  get pF() { return this.passForm.controls; }

  updatePassword() {
    // Set Submission True
    this.passSubmitted        = true;

    // Stop here if form is invalid
    if (this.agentForm.invalid || this.passwordChange.oldPass != this.agentDetails.password || this.passwordChange.newPass != this.passwordChange.verifyPass) {
     return;
    }

    // Show Loader
    this.loader = true;

    let url = AppSettings.API_ENDPOINT + "shared/update-agent-password";
    let data = { password: this.passwordChange.newPass };

    this.helperService.httpPostRequests(url, data).then(resp => {
        if(typeof resp != "undefined") {
          if(resp && resp.status == 'OK') {
            Swal.fire('', resp.message, 'success');

            // Update Old Pass
            this.agentDetails.password = this.passwordChange.newPass;
          }
          else
            Swal.fire('', JSON.stringify(resp.message), 'error');
        }

        // Hide Modal
        ($('#resetPassword') as any).modal('hide');

        // Hide Loader
        this.loader = false;
    }).catch(err => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');


        // Hide Loader
        this.loader = false;
    });
  }

  openImageUpload() {
    this.Pond_Img.browse();
  }

  pondHandleInit() {
    console.log('FilePond has initialised');
  }

  pondHandleAddFile(event: any) {
    // Show File Upload Loader
    this.FileLoader = true;

    // Show Pond picker
    this.hideFilePond = false;

    console.log('A file was added', event);
  }

  ponfHandleRemoveFile(event: any) {
    // Hide File Upload Loader
    this.FileLoader = false;
  }

  pondHandleActivateFile(event: any) {
    console.log('A file was activated', event)
  }
}
